import { Component, OnInit, trigger, state, style, transition, animate, Input,  Output, EventEmitter } from '@angular/core';

import { ParametreRecherche } from './../modeles/parametre-recherche.model';

@Component({
  selector: 'cm-recherche',

  template: `
    <div class="ecran-recherche" 
        [@afficherCacherEcran]="etatEcran">

        <div class="cadre-fermer" (click)="fermer()"> <img class="img image-fermer" src="./assets/images/croix.png"/> </div>

        <div class="cadre-defilement">

            <div class="cadre-recherche row">
              <h3>Rechercher un lieu marial</h3>

              <div class="cadre-recherche-haut row">
                <input 
                  #txtrecherche
                  class="texte-recherche" 
                  type="text" 
                  [value]="parametreRecherche.texteRecherche"
                  (keyup.enter)="rechercherTexte($event.target.value)"
                  placeholder="RECHERCHE" />
                <div class="bouton-recherche text-center"
                  (click)="rechercherTexte(txtrecherche.value)"> 
                  <i class="fa fa-search" aria-hidden="true"></i> 
                </div>
              </div>

              <hr>

              <!--<h4>Recherche par catégories</h4>
              <ul>
                  <li> <input type="checkbox" /> Les principaux sanctuaires </li>
                  <li> <input type="checkbox" /> Les apparitions reconnues </li>
                  <li> <input type="checkbox" /> Les autres apparitions </li>
                  <li> <input type="checkbox" /> Pélérinages régionaux </li>
                  <li> <input type="checkbox" /> Pélérinages locaux </li>
                  <li> <input type="checkbox" /> Lieux de commomération </li>
              </ul>-->

            </div>

            <div class="cadre-resultat" *ngIf="parametreRecherche.texteRecherche !==''">
              <h3>Résultat de la recherche </h3> 
                <cm-recherche-resultat
                  *ngFor="let site of sitesAffiches"
                  [site]="site"
                  [favoris]="false"
                  (selectionner)="selectionnerSite($event)">
                </cm-recherche-resultat>
            </div>

        </div>

    </div>
  `,

  styles: [`
    .ecran-recherche {
      position: absolute;
      top: 0;
      left: 60vw;
      width: calc(40vw - 60px);
      height: calc(100vh - 50px);
      background-color: white;
      border: 1px solid lightgray;
      overflow: hidden;
    }
    .cadre-defilement {
        padding: 30px 0px 0px 0px;
        height: calc(100vh - 50px - 50px);
        overflow-x: hidden;
        overflow-y: auto;
      }
      .cadre-fermer {
          height: 50px;
      }
      .image-fermer {
          position: relative;
          top: 10px;
          left: calc(100% - 40px);
          width: 25px;
          height: 25px;
          cursor: pointer;
      }
    .cadre-recherche {
      padding-left: 45px;
    }
    .cadre-recherche-haut {
      display: flex;
    }
    .texte-recherche {
      margin-left: 15px;
      height: 40px;
      width: 320px;
      max-width: 50%;
      font-size: 16px;
    }
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: lightgray;
    }
    ::-moz-placeholder { /* Firefox 19+ */
      color: lightgray;
    }
    :-ms-input-placeholder { /* IE 10+ */
      color: lightgray;
    }
    :-moz-placeholder { /* Firefox 18- */
      color: lightgray;
    }
    .bouton-recherche {
      margin-left: 15px;
      width: 100px;
      background-color: #FFA300;
      height: 40px;
      padding: 6px;
      cursor: pointer;
    }
    .fa {
      font-size: 26px;
      color: white;
    }
    h4 {
      font-weight: 700;
    }
    ul {
      list-style-type: none;
    }
    li {
      margin-bottom: 10px;
      font-size: 18px;
    }
    input[type=checkbox] {
      -ms-transform: scale(2);
      -moz-transform: scale(2); 
      -webkit-transform: scale(2);
      -o-transform: scale(2); 
      padding: 10px;
      margin-right: 10px;
    }
    .cadre-resultat {
      margin-top: 30px;
      background-color: rgb(233, 233, 233);
      border-top: 1px solid lightgray;
      padding-left: 35px;
      padding-bottom: 30px;
    }


    @media (max-width: 800px), (max-height: 700px) { 
        .ecran-recherche {
            left: 0;
            width: 100vw;
            height: 100vh;
        }
        .cadre-recherche {
          padding: 10px 15px 10px 30px;
        }
         .texte-recherche {
          width: 200px;
        }
        .bouton-recherche {
          width: 60px;
          margin-left: 3px;
        }
        .cadre-resultat {
          margin-top: 10px;
          padding-left: 25px;
          padding-bottom: 10px;
        }
    }
  `],

  animations: [
    trigger('afficherCacherEcran', [
      state('visible', style({
      transform: 'translateX(0) scale(1, 1)'
      })),
      state('invisible', style({
          transform: 'translateX(100%) scale(0, 1)'
      })),
      transition('visible => invisible', animate('400ms ease-in-out')),
      transition('invisible => visible', animate('400ms ease-in-out'))
    ]),
  ]
})
export class RechercheComponent implements OnInit {
  @Input() etatEcran: string;
  @Input() sitesAffiches: any[];
  @Input() parametreRecherche: ParametreRecherche;
  @Output() fermerEcran: EventEmitter<any> = new EventEmitter();
  @Output() rechercher: EventEmitter<string> = new EventEmitter();
  @Output() selectionner: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {
  }

  fermer() {
    this.parametreRecherche.texteRecherche = '';
    this.rechercher.emit('');
    this.fermerEcran.emit();
  }

  rechercherTexte(texte: string) {
    this.parametreRecherche.texteRecherche = texte;
    this.rechercher.emit(texte);
  }

  selectionnerSite(site: any) {
    this.fermer();
    this.selectionner.emit(site);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/recherche.component.ts